import { Auth } from 'aws-amplify';
import { instance, instanceWithoutToken } from 'utils/axios';
import config from 'utils/config';

const baseURL = process.env.REACT_APP_APPLICANTMANAGEMENTAPI ? process.env.REACT_APP_APPLICANTMANAGEMENTAPI : config.applicantManagementAPI;

export const getCountryServices = async () => {
    instance.defaults.headers.post['JJKAuthTF'] = "";
    return await instance.get('api/wizard/GetCountry');
};

export const getStateServices = async countryCode => {
    instance.defaults.headers.post['JJKAuthTF'] = "";
    return await instance.post('api/wizard/GetState', countryCode);
};

export const getCountyServices = async (stateCode) => {
    instance.defaults.headers.post['JJKAuthTF'] = "";
    return await instance.post('api/wizard/GetCountyList', stateCode);
};

export const getAzureMapsSearchServices = async (params, signal) => {
    instance.defaults.headers.post['JJKAuthTF'] = "";

    const sanitizedParams = {};
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            sanitizedParams[key] = value;
        }
    });

    const response = await instance.get('api/AzureMaps/Search', {
        params: sanitizedParams,
        signal
    });

    return response.data;
};

export const JobDetailsServices = async jobInfo => {
    instanceWithoutToken.defaults.headers.post['JJKAuthTF'] = jobInfo.key;
    return await instanceWithoutToken.post('api/wizard/GetJobOpeningDetails', jobInfo.payload);
};

export const addApplicantServices = async request => {
    instance.defaults.headers.post['JJKAuthTF'] = "";
    return await instance.post('api/wizard/AddApplicant', request);
};

export const sendMailOnLogoutServices = async request => {
    instance.defaults.headers.post['JJKAuthTF'] = "";
    return await instance.post('api/wizard/SendMailOnLogout', request);
};

export const addRegisteredUserServices = async request => {
    instanceWithoutToken.defaults.headers.post['JJKAuthTF'] = request.key;
    return await instanceWithoutToken.post('api/wizard/AddRegisteredUserDetail', request.payload);
};

export const updateUserPasswordModifiedDetailServices = async request => {
    instanceWithoutToken.defaults.headers.post['JJKAuthTF'] = "";
    return await instanceWithoutToken.post('api/wizard/UpdateUserPasswordModifiedDetail', request);
};

export const getUserPasswordModifiedDetailServices = async request => {
    instance.defaults.headers.post['JJKAuthTF'] = request.key;
    return await instance.post('api/wizard/GetUserPasswordModifiedDetail', request.payload);
};

export const GetAllAplicationsForApplicantServices = async request => {
    instance.defaults.headers.post['JJKAuthTF'] = request.key;
    return await instance.post('api/wizard/GetAllAplicationsForApplicant', request.payload);
};

export const GetApplicantJobInviteExistsServices = async request => {
    instanceWithoutToken.defaults.headers.post['JJKAuthTF'] = "";
    return await instanceWithoutToken.post('api/wizard/GetApplicantJobInviteExists', request);
};

export const getPublicToken = async() => {
    instance.defaults.headers.post['JJKAuthTF'] = "";
    return await instanceWithoutToken.get('api/wizard/GetPublicToken');
};